import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ViewOutcomeModalPage } from './view-outcome-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ViewOutcomeModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ViewOutcomeModalPage]
})
export class ViewOutcomeModalPageModule { }
